__turbopack_context__.v({
  "container": "MoreWaysToWin-module__q3GA3a__container",
  "detailsWrapper": "MoreWaysToWin-module__q3GA3a__detailsWrapper",
  "enterButton": "MoreWaysToWin-module__q3GA3a__enterButton",
  "header": "MoreWaysToWin-module__q3GA3a__header",
  "itemTextWrapper": "MoreWaysToWin-module__q3GA3a__itemTextWrapper",
  "priceRow": "MoreWaysToWin-module__q3GA3a__priceRow",
  "priceText": "MoreWaysToWin-module__q3GA3a__priceText",
  "separator": "MoreWaysToWin-module__q3GA3a__separator",
  "thumbnail": "MoreWaysToWin-module__q3GA3a__thumbnail",
  "thumbnailImage": "MoreWaysToWin-module__q3GA3a__thumbnailImage",
  "thumbnailOverlay": "MoreWaysToWin-module__q3GA3a__thumbnailOverlay",
  "timerBadge": "MoreWaysToWin-module__q3GA3a__timerBadge",
  "timerText": "MoreWaysToWin-module__q3GA3a__timerText",
  "title": "MoreWaysToWin-module__q3GA3a__title",
  "titleWrapper": "MoreWaysToWin-module__q3GA3a__titleWrapper",
  "tokenRedemptionOption": "MoreWaysToWin-module__q3GA3a__tokenRedemptionOption",
  "tokenRedemptionOptionsContainer": "MoreWaysToWin-module__q3GA3a__tokenRedemptionOptionsContainer",
});
